import {del, get, post, put} from '../../utils/ApiUtil';
import Admin from '../../models/Admin';
import Page from '../../filters/Page';

/**
 * 管理者の一覧を取得
 *
 * @param filter
 * @returns {Promise<*>}
 */
export async function getAdmins(filter) {
  const data = await get('/api/admin/admins', filter);
  return data.map(a => new Admin(a));
}

/**
 * 管理者の一覧を取得（ページネーション）
 *
 * @param filter
 * @returns {Promise<Page>}
 */
export async function getPaginatedAdmins(filter) {
  const data = await get('/api/admin/admins/paginated', filter);
  return new Page(data, Admin);
}

/**
 * 管理者の詳細を取得
 *
 * @param id
 * @returns {Promise<Admin>}
 */
export async function getAdmin(id) {
  const data = await get('/api/admin/admins/' + id);
  return new Admin(data);
}

/**
 * 管理者を更新
 *
 * @param admin
 * @returns {Promise<Admin>}
 */
export async function updateAdmin(admin) {
  const data = await put('/api/admin/admins/' + admin.id, admin);
  return new Admin(data);
}

/**
 * 管理者を削除
 *
 * @param admin
 * @returns {Promise<void>}
 */
export async function deleteAdmin(admin) {
  await del('/api/admin/admins/' + admin.id, {});
}
